<template xmlns:v-slot="http://www.w3.org/1999/html">
	<div class="kt-portlet kt-portlet--height-fluid mt-3">
		<div
			class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm flex-wrap"
		>
			<div class="kt-portlet__head-label mb-2">
				<span class="kt-portlet__head-icon">
					<v-icon>fab fa-wpforms</v-icon>
				</span>
				<h3 class="kt-portlet__head-title">Internet Shop Custom Forms</h3>
			</div>
			<div class="kt-portlet__head-label mb-2 float-right">
				<v-btn
					small
					@click="
						$router.push({
							name: 'CreateInternetShopCustomForm',
						})
					"
					color=" primaryMain"
					dark
					class="primaryMainText--text mb-2 mr-2"
					style="color: white !important"
				>
					Create New Form
				</v-btn>
			</div>
		</div>
		<div class="kt-portlet__body">
			<v-data-table :headers="headers" :items="customForms" :loading="loadings.dataTable">
				<template v-slot:item.created_at="{ item }">
					{{ item.created_at | displayDateTime }}</template
				>
				<template v-slot:item.action="{ item }">
					<v-btn text color="blue darken-3" small>
						<v-icon small>fal fa-eye</v-icon>
					</v-btn>
					<v-btn text color="grey darken-3" small>
						<v-icon small>fal fa-edit</v-icon>
					</v-btn>
					<v-btn text color="red darken-3" small>
						<v-icon small>fal fa-trash</v-icon>
					</v-btn>
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
export default {
  name: 'InternetShopCustomForm',
  data() {
    return {
      states: {
        customForm: false,
      },
      headers: [
        {
          text: 'Title',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Date Created',
          value: 'created_at',
          sortable: true,
        },
      ],
      pagination: {
        currentPage: 1,
      },
      loadings: {
        dataTable: false,
      },
    };
  },
  computed: {
    customForms() {
      return this.$store.state.internetShopCustomForm.customForms;
    },
  },
  watch: {},
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loadings.dataTable = true;

      const params = new URLSearchParams([['current_page', this.pagination.currentPage]]);

      this.axios.get('v3/internet-shops/custom-forms', { params }).then(({ data }) => {
        this.$store.dispatch('internetShopCustomForm/setCustomForms', data.data.data);

        this.$nextTick(() => {
          this.loadings.dataTable = false;
        });
      });
    },
  },
};
</script>
